// @ts-nocheck
import { Breadcrumb, BreadcrumbItem, Col, Container, LinkList, LinkListItem, Row } from 'design-react-kit';
import React, { useState, useContext } from 'react';
import WidgetEvent from './widget_event';
import WidgetSearch from '../../pages/components/widget_search';
import WidgetTags from 'apps/tags/components/widget_tags';
import ApiService from '../../../services/api';
import { useEffect } from 'react';
import { WidgetClass } from '../../pages/models/widget';
import WidgetCategory from 'apps/categories/components/widget_category';
import WidgetPageRating from 'pa_kit/apps/page_evaluation/components/widget_page_rating';
import WidgetContacts from 'pa_kit/apps/contacts/components/widget_contacts';
import { ActaAuthContext } from "pa_kit/auth";
import { LocalSettingsContext } from "services/local_settings";
import { Helmet } from "react-helmet-async";


const PageEvents = () => {

    const settings = useContext(LocalSettingsContext);
    const auth = useContext(ActaAuthContext);

    const localSettings = settings.localSettings;
    const organization = auth.organization;

    const eventsParentCategory = localSettings.events_parent_category === null ? 'Novità' : localSettings.events_parent_category_data.title
    const eventsParentCategorySlug = localSettings.events_parent_category === null ? 'novita' : localSettings.events_parent_category_data.slug

    const [ categoryList, setCategoryList ] = useState();
    const [ mainSection, setMainSection ] = useState({});

    const [ widgetLatestEvents ] = useState(new WidgetClass({
        name: "LatestEvents",
        class: "latest-events",
        category: "all",
        show_number: 3,
        label: <span></span>
    }));

    const [ widgetSearch ] = useState(new WidgetClass({
        name: "SearchSection",
        class: "search-allevents-section",
        type: "search",
        label: "Cerca eventi",
        search_in: "main_sections",
        search_id: 7
    }));

    const [ widgetTags ] = useState(new WidgetClass({
        name: "EventiRowContent",
        class: "eventi-row-content",
        type: "tags",
        list_style: "chips" 
    }));

    const [widgetCategories] = useState(new WidgetClass({
        name: "CategoriesList",
        class: "categories-list-row",
        category_type: "events"
    }));

    // const fetchCategoryList = async() => {
    //     const categoryListData = await ApiService.getCategoryList();
    //     const categoryList = categoryListData.filter(category => category.is_event === true);
    //     setCategoryList(categoryList);
    // }

    const fetchCategoryList = async() => {
        let categoryArray = [];
        const categoryListData = await ApiService.getCategoryList();
        const categoryList = categoryListData.filter(category => category.is_event === true);
        Promise.all(categoryList.map((category) => ApiService.getLatestEventsByCategory(category.id))).then((events) => {
            events.forEach((event) => {
                if(event.length > 0) {
                    categoryArray.push(event[0].category.id);
                }
            });
            const categoryEvents = categoryList.filter(cat => categoryArray.includes(cat.id));
            setCategoryList(categoryEvents);
        });
    }

    const fetchMainSections = async() => {
        const mainSectionsData = await ApiService.getMainSections();
        const mainSection = mainSectionsData.filter(main_section => main_section.id === 7); //Eventi
        setMainSection(mainSection[0]);
    }

    useEffect(() => {
        fetchCategoryList();
        fetchMainSections();
    }, []);

    return <>
        <Helmet>
            <title>{mainSection.name + ' | ' + organization.name}</title>
            <meta name="description" content={mainSection.description} />
        </Helmet>
        <Container fluid className="p-0 events-main-wrapper">
            <Container className="pt-5 px-3">
                <Row>
                    <Col>
                        <Breadcrumb>
                            <BreadcrumbItem>
                                <a href='/'>Home</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                <a href={'/' + eventsParentCategorySlug + '/'}>{eventsParentCategory}</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                {mainSection.name}
                            </BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </Row>
            </Container>

            <Container className={'page-title events-page-title-page pb-5'}>
                <Row>
                    <Col lg="7">
                        <h1 data-element="page-name">{mainSection.name}</h1>
                        <div className="mt-4">{mainSection.description}</div>
                        <WidgetSearch widget={widgetSearch} />
                    </Col>
                    <Col lg="5">
                    <Container fluid className={'events-page-menu page-menu-content ms-lg-5 ps-lg-5'}>
                        <p className="menu-name mb-2">{mainSection.name}</p>
                        <LinkList>
                            {categoryList && categoryList.map((category) => 
                                <LinkListItem key={"key_menuItem_" + category.name} href={eventsParentCategorySlug === 'novita' ? '/novita/eventi/' + category.slug + '/' : '/eventi/' + category.slug + '/'} className="ps-0 menu-item-link">{category.name}</LinkListItem>
                            )}
                        </LinkList>
                    </Container>
                    </Col>
                </Row>
            </Container>

            <Container>
                <h2 className="events-page-category-title mb-4 px-1">In evidenza</h2>  
            </Container>

            <Container fluid className="latest-events-page-events-section">
                <Container>                                
                    <WidgetEvent widget={widgetLatestEvents} />
                </Container>
            </Container>

            <Container>
                <WidgetCategory widget={widgetCategories} />
            </Container>
        
            <Container className="mt-5">
                <h2 className="events-page-category-title mb-4 px-1">Argomenti</h2>  
            </Container>        
            
            <Container className="text-center mb-5 mt-5 pb-5">
                <WidgetTags widget={widgetTags} />
            </Container> 

            <Container fluid className={'rating-wrapper page-rating events-page-rating'}>
                <WidgetPageRating page_title={mainSection.name}/>
            </Container>

            <Container fluid className={'contacts-wrapper events-page-contacts'}>
                <WidgetContacts />
            </Container>        

        </Container>       
    </>;
}

export default PageEvents;